// modal.js
import Swal from 'sweetalert2';

// Map modal types to SweetAlert2 icons
const iconMap = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
};

// Hebrew button labels
const hebrewLabels = {
  confirmButtonText: 'אישור',
  cancelButtonText: 'ביטול'
};

export const showModal = (message, type, confirmAction = false) => {
  const options = {
    text: message,
    icon: iconMap[type] || 'info',
    confirmButtonText: hebrewLabels.confirmButtonText,
    confirmButtonColor: type === 'success' ? '#4CAF50' : type === 'error' ? '#D32F2F' : '#026ACC',
    allowOutsideClick: !confirmAction,
    allowEscapeKey: !confirmAction,
  };

  if (confirmAction) {
    options.showCancelButton = true;
    options.cancelButtonText = hebrewLabels.cancelButtonText;
    options.cancelButtonColor = '#C62828';
    options.reverseButtons = true; // RTL support

    return Swal.fire(options).then((result) => result.isConfirmed);
  }

  return Swal.fire(options).then(() => undefined);
};

// Keep these exports for backward compatibility (some files may import them)
export const isModalVisible = { value: false };
export const modalMessage = { value: '' };
export const modalType = { value: '' };
export const isConfirmAction = { value: false };
export const closeModal = () => Swal.close();
